import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IData, IEvent, IEventListResponse, IEventResponse } from '../models/event';
import config from '../../../../config.js';
import { ICard } from '../../../shared/models/card.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TodoService {
  private archivedDataSubject = new BehaviorSubject<IData[]>([]);
  private nonArchivedDataSubject = new BehaviorSubject<IData[]>([]);

  archivedData = true;
  nonArchivedData = [];

  get archivedData$(): Observable<IData[]> {
    return this.archivedDataSubject.asObservable();
  }

  get nonArchivedData$(): Observable<IData[]> {
    return this.nonArchivedDataSubject.asObservable();
  }

  setFullData(data: IData[]) {
    const archived = data.filter(item => item.isArchived === 'True');
    const nonArchived = data.filter(item => item.isArchived === 'False');
    this.archivedDataSubject.next(archived);
    this.nonArchivedDataSubject.next(nonArchived);
  }

  archiveItem(rowId: string) {
    const currentNonArchived = this.nonArchivedDataSubject.value;
    const updatedNonArchived = currentNonArchived.filter(item => item.PackingListReferenceNumber !== rowId);
    const archivedItem = currentNonArchived.find(item => item.PackingListReferenceNumber === rowId);

    if (archivedItem) {
      this.archivedDataSubject.next([...this.archivedDataSubject.value, { ...archivedItem, isArchived: 'True' }]);
    }
    this.nonArchivedDataSubject.next(updatedNonArchived);
  }

  /*getData(): Observable<IEventListResponse> {
    return this.http.get<IEventListResponse>(this.apiUrl + '?pageSize=100');
  }

  getData(): Observable<IEventListResponse> {
    console.log(this.apiUrl + '?pageSize=5');
    return this.http.get<IEventListResponse>(this.apiUrl + '?pageSize=5');
  }

  updateEntry(entry: IData): Observable<IEventResponse> {
    return this.http.put<IEventResponse>(this.apiUrl + '/update', entry);
  }

  uploadImage(base64Image: string): Observable<any> {
    const payload = { 'content': base64Image };
    return this.http.post(this.apiUrl + '/upload', payload);
  }
  */
}
